module.exports = __webpack_public_path__ + "img/EN.610bc43a.svg";